import http from '@/biz/http.mjs'

export default {
    readList: (args) => http.get('/rmsfs', {...args, sfTypeCode: 'EXPERIENCE'}),
}
